import Vue from "vue";

// This imports all the layout components such as <b-container>, <b-row>, <b-col>:
import {
  AlertPlugin,
  ButtonPlugin,
  CardPlugin,
  CollapsePlugin,
  DropdownPlugin,
  FormCheckboxPlugin,
  FormFilePlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormPlugin,
  FormRadioPlugin,
  FormSelectPlugin,
  FormTagsPlugin,
  FormTextareaPlugin,
  InputGroupPlugin,
  LayoutPlugin,
  ListGroupPlugin,
  ModalPlugin,
  PaginationPlugin,
  PopoverPlugin,
  ProgressPlugin,
  SpinnerPlugin,
  TablePlugin,
  TabsPlugin,
  TooltipPlugin,
} from "bootstrap-vue";

Vue.use(LayoutPlugin);
Vue.use(ModalPlugin);
Vue.use(PopoverPlugin);
Vue.use(AlertPlugin);
Vue.use(CollapsePlugin);
Vue.use(FormPlugin);
Vue.use(FormFilePlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormTagsPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormRadioPlugin);
Vue.use(ListGroupPlugin);
Vue.use(ButtonPlugin);
Vue.use(InputGroupPlugin);
Vue.use(TablePlugin);
Vue.use(ProgressPlugin);
Vue.use(SpinnerPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormInputPlugin);
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(DropdownPlugin);
Vue.use(TooltipPlugin);
Vue.use(PaginationPlugin);
